module.exports = __webpack_public_path__ + "img/m4x85_gb70.prt.51ecbc04.jpg";